import { LocalStorageService } from 'App/Services/General/LocalStorageService';

(window as any).getUserInfo = LocalStorageService.getUserInfo;
(window as any).logUserOut = LocalStorageService.clearAll;
